<template>
  <el-dialog
    :visible.sync="visible"
    :title="title"
    width="400px">
    <div class="des">{{des}}</div>
    <el-input
      type="textarea"
      :rows="8"
      :placeholder="placeholder"
      v-model="textarea">
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="textarea = ''">清空</el-button>
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleOK">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    maxCount: {
      type: Number,
      default: 0,
    },
    desText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      textarea: '',
      successCB: null
    }
  },
  computed: {
    title() {
      return `请输入${this.label}`
    },
    des() {
      return this.desText || `多个，以英文逗号分割或每行一个${this.maxCount > 0 ? '，最多输入' + this.maxCount + '个' : ''}`
    },
    placeholder() {
      return `请输入${this.label}`
    }
  },
  methods: {
    handleOK() {
      const cbValue = this.textarea.replace(/\n/g, ',').split(',').filter(Boolean);
      if (this.maxCount > 0 && cbValue.length > this.maxCount) {
        this.$message.error(`单次最多支持输入${this.maxCount}个${this.label}进行查询`);
        return false;
      }
      this.successCB && this.successCB(cbValue.join(','))
      this.visible = false
    },
    method_open(textarea, successCB) {
      this.textarea = textarea
      this.visible = true
      this.successCB = successCB
    }
  }
}
</script>

<style lang="scss" scoped>
.des {
  margin-bottom: 10px;
}
</style>